import { NavLink, Navigate, Outlet } from "react-router";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../lib/auth";
import { AdminSessionProvider, useAdminSession } from "../../lib/AdminSessionContext";
import { StoreStatusAdminToggle } from "../../components/StoreStatusAdminToggle";
import "./admin.css";

function VisitPill() {
  const { visitorEmail, clear } = useAdminSession();
  if (!visitorEmail) return null;
  return (
    <div className="admin__visit-pill" role="status" aria-live="polite">
      <span className="admin__visit-pill-label">Visita actual:</span>
      <strong>{visitorEmail}</strong>
      <button type="button" className="admin__visit-pill-clear" onClick={clear}>
        terminar
      </button>
    </div>
  );
}

export function AdminLayout() {
  const { t } = useTranslation();
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="container">
        <p>{t("common.loading")}</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") {
    return (
      <div className="container">
        <div className="surface" role="alert">
          <h1>{t("admin.restrictedTitle")}</h1>
          <p>{t("admin.restrictedBody")}</p>
        </div>
      </div>
    );
  }

  return (
    <AdminSessionProvider>
      <div className="container admin">
        <header className="admin__head">
          <h1>{t("admin.title")}</h1>
          <div className="admin__head-controls">
            <StoreStatusAdminToggle />
            <VisitPill />
          </div>
        </header>
        <nav className="admin__tabs" aria-label={t("admin.title")}>
          <NavLink to="/admin/checkin" end>{t("admin.tabCheckIn")}</NavLink>
          <NavLink to="/admin/checkout" end>{t("admin.tabCheckOut")}</NavLink>
          <NavLink to="/admin/holds" end>{t("admin.tabHolds")}</NavLink>
          <NavLink to="/admin/livros" end>{t("admin.tabBooks")}</NavLink>
          <NavLink to="/admin/creditos" end>{t("admin.tabCredits")}</NavLink>
          <NavLink to="/admin/horarios" end>{t("admin.tabHours")}</NavLink>
          <NavLink to="/admin/stats" end>{t("admin.tabStats")}</NavLink>
        </nav>
        <Outlet />
      </div>
    </AdminSessionProvider>
  );
}
